const crmApiBase = process.env.REACT_APP_API || "";

const getCrmEndpoint = (controller, action, storeId) => {
  if (!storeId) {
    throw new Error("StoreId is required for CRM API calls.");
  }
  return `${crmApiBase}Crm/${controller}/${action}/${storeId}`;
};

export const getCrmEndpointWithId = (controller, action, storeId, id) => {
  if (!storeId) {
    throw new Error("StoreId is required for CRM API calls.");
  }
  if (!id) {
    throw new Error("Record id is required for this CRM API call.");
  }
  return `${crmApiBase}Crm/${controller}/${action}/${storeId}/${id}`;
};

export const fetchCrmList = async (controller, action, storeId) => {
  const endpoint = getCrmEndpoint(controller, action, storeId);
  const response = await fetch(endpoint);
  if (!response.ok) {
    throw new Error(`CRM API request failed: ${response.status}`);
  }
  return response.json();
};

export const saveCrmItem = async (controller, action, payload) => {
  const endpoint = `${crmApiBase}Crm/${controller}/${action}`;
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`CRM save failed: ${response.status} ${text}`);
  }
  return response.json();
};

export const deleteCrmItem = async (controller, action, storeId, id) => {
  const endpoint = getCrmEndpointWithId(controller, action, storeId, id);
  const response = await fetch(endpoint, {
    method: "DELETE",
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`CRM delete failed: ${response.status} ${text}`);
  }
  return true;
};
